import {CommonModule} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule, ErrorHandler, APP_INITIALIZER} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {ToastrModule} from 'ngx-toastr';
// import {TranslateModule} from '@ngx-translate/core';
// import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
// import { FullCalendarModule } from 'ng-fullcalendar';
import {FullCalendarModule} from '@fullcalendar/angular';

import {AddHeaderInterceptor} from './shared/jwt.interceptor';
import {GlobalErrorHandler} from './shared/chunkfailedreloader.errorhandler';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LogoutComponent} from './shared/login/logout.component';
import {VerifyEmailComponent} from './shared/login/verify_emailtoken.component';
import { ParentAccountRegistrationComponent} from './shared/parent_account_registration/components/parent_account_registration.component'
import { TensParentRegistrationComponent} from './shared/parent_account_registration/components/tens_parent_registration.component'
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatMenuModule} from '@angular/material/menu';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import { AgmCoreModule } from '@agm/core';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import { TemporaryAdmissionComponent } from './shared/parent_account_registration/components/temporary_regform.component';
import { TemporaryClassNPhotoComponent } from './shared/parent_account_registration/components/temp_regform_class_nPhoto.component'
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import { MatNativeDateModule } from '@angular/material/core';
// import { MatStepperModule } from '@angular/material/stepper';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCardModule } from '@angular/material/card';
import { RegistrationStatusComponent } from './shared/parent_account_registration/components/registration_status.component';

import {OnlineApplicationHomeComponent} from './shared/online_admission_form_components/online_application_home_components/online_application_home.component';
import {OnlineApplicationFormComponent} from './shared/online_admission_form_components/online_application_form_components/online_application_form.component';

export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function HttpLoaderFactory(httpClient: HttpClient) {
	return new TranslateHttpLoader(httpClient);
}

@NgModule({
	declarations: [
		AppComponent,
		LogoutComponent,
		VerifyEmailComponent,
		ParentAccountRegistrationComponent,
		TensParentRegistrationComponent,
		TemporaryAdmissionComponent,
		TemporaryClassNPhotoComponent,
		RegistrationStatusComponent,
		OnlineApplicationHomeComponent,
		OnlineApplicationFormComponent
		// PasswordResetComponent,
	],
	imports: [    
		CommonModule,
		ReactiveFormsModule,
		AppRoutingModule,MatNativeDateModule,
		HttpClientModule,MatCheckboxModule,
		FormsModule,MatIconModule,
		FullCalendarModule,MatDatepickerModule,
		BrowserAnimationsModule,
		MatButtonModule,MatInputModule,
		MatSelectModule,MatMenuModule,MatDialogModule,
		ToastrModule.forRoot(), // ToastrModule added
		AgmCoreModule.forRoot({
			apiKey: ''
		}),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: createTranslateLoader,
				deps: [HttpClient]
			}
		}),
		MatExpansionModule,
		MatTabsModule,
		MatStepperModule,
		MatCardModule,

	],
	providers: [
		{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
		{provide: HTTP_INTERCEPTORS, useClass: AddHeaderInterceptor, multi: true,}
	],
	bootstrap: [AppComponent]
})
export class AppModule {
}
